export default __webpack_public_path__ + "static/media/Asset 16.41235ae8.png";